import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  const renderPrice = () => {
    if (product.variantPrices) {
      const prices = Object.values(product.variantPrices);
      const uniquePrices = [...new Set(prices)].sort(
        (a, b) => parseFloat(a) - parseFloat(b)
      );
      if (uniquePrices.length > 1) {
        return `$${uniquePrices.join(" / $")}`;
      }
    }
    return `$${product.price}`;
  };

  return (
    <div className="product-detail">
      <div className="product-detail__container">
        <div className="product-detail__left">
          <div className="product-detail__main-image">
            <img
              src={product.images?.[selectedImage] || product.image}
              alt={product.name}
            />
          </div>
          {product.images && product.images.length > 1 && (
            <div className="product-detail__thumbnails">
              {product.images.map((img, idx) => (
                <div
                  key={idx}
                  className={`product-detail__thumbnail ${
                    selectedImage === idx ? "active" : ""
                  }`}
                  onClick={() => setImage(idx)}
                >
                  <img src={img} alt={`${product.name} thumbnail ${idx + 1}`} />
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="product-detail__right">
          <h1 className="product-detail__title">{product.name}</h1>
          <p className="product-detail__price">{renderPrice()}</p>

          <div className="product-detail__description">
            {product.description?.map((desc, idx) => (
              <p key={idx}>{desc}</p>
            ))}
          </div>

          <div className="product-detail__actions">
            {product.size && product.size.length > 0 && (
              <div className="product-detail__option">
                <label>
                  {product.size.some((s) => s.toLowerCase().includes("edition"))
                    ? "Edition"
                    : "Size"}
                </label>
                <div className="select-wrapper">
                  <select
                    value={selectedSize}
                    onChange={(e) => setSelectedSize(e.target.value)}
                  >
                    {product.size.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            {product.colors && product.colors.length > 0 && (
              <div className="product-detail__option">
                <label>Color</label>
                <div className="select-wrapper">
                  <select
                    value={selectedColor}
                    onChange={(e) => setSelectedColor(e.target.value)}
                  >
                    {product.colors.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="product-detail__option">
              <label>Quantity</label>
              <input
                type="number"
                min="1"
                value={quantity}
                onChange={(e) =>
                  setQuantity(Math.max(1, parseInt(e.target.value) || 1))
                }
                className="quantity-input"
              />
            </div>

            <button
              className="product-detail__add-to-cart"
              onClick={() => {
                addToCart(product.id, quantity, selectedSize, selectedColor);
                navigate("/cartpage");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              ADD TO CART
            </button>
          </div>

          <div className="product-detail__back">
            <Link onClick={toTop} to="/shop">
              <span className="arrow">←</span> BACK TO ALL PRODUCTS
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
